module.exports = __webpack_public_path__ + "img/vdm150_c.a6d73406.png";